import React, { useState } from "react";
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  Stack
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

import LocAutoComplete from "../../../components/AutoComplete/LocAutoComplete";
import CustomDateRangePicker from "../../../components/CustomDateRangePicker";
import ResponsiveGrid from "../../../components/GridCustomComponent";
import PermissionWrapper from "../../Setting/PermissionWrapper";

import {
  formatedDateRangeFunc,
  formatDateRange,
  isDateDiffGreaterThan31
} from "../../../utils/global-functions";

const DocumentAuditFilterSection = ({
  onApplyFilters,
  onClearFilters,
  selectedLocationList,
  setSelectedLocationList,
  isExpanded,
  setIsExpanded,
  hasUnsavedRows,
  isSaving,
  handleSave,
  handleCancel
}) => {
  const [dateType, setDateType] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [selectedDate, setSelectedDate] = useState("");

  const [isPickerOpen, setIsPickerOpen] = useState(false);

  /* ---------------- APPLY ---------------- */

  const handleApply = () => {
    if (dateType && (!dateRange[0] || !dateRange[1])) {
      return alert("Please select valid date range!");
    }

    // if (selectedLocationList.length > 1 && dateRange[0]) {
    //   const isInvalid = isDateDiffGreaterThan31(dateRange);
    //   if (isInvalid) {
    //     return alert(
    //       "When multiple locations are selected, date range must be 30 days or less."
    //     );
    //   }
    // }

    onApplyFilters({
      dateType,
      dateRange
    });
  };


  const handleClear = () => {
    setDateType("");
    setDateRange([null, null]);
    setSelectedDate("");
    onClearFilters();
  };

  const handleAccept = (index, dateValue) => {
    const { formattedStartDate, formattedEndDate } =
      formatDateRange(dateValue);

    setDateRange([formattedStartDate, formattedEndDate]);
    setSelectedDate(`${formattedStartDate}|${formattedEndDate}`);
    setIsPickerOpen(false);
  };

  return (
    <Box sx={{ p: 2, boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}>
      {/* -------- HEADER -------- */}
      <ResponsiveGrid gridValues={[12]}>
        <Box
          display="flex"
          alignItems="center"
          mb={2}
          position="relative"
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: "#0911A7",
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)"
            }}
          >
            Required Document Audit
          </Typography>

          <Box ml="auto">
            <Button variant="outlined" onClick={() => setIsExpanded(!isExpanded)}>
              {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Button>
          </Box>
</Box>

      </ResponsiveGrid>

      {/* -------- FILTER BODY -------- */}
      <Box sx={{ display: isExpanded ? "block" : "none" }}>
        <ResponsiveGrid gridValues={[2, 2, 2, 2,2,2]}>
          {/* Location */}
          <LocAutoComplete
          multiple={false}
            seletedLocationList={selectedLocationList}
            setSelectedLocationList={setSelectedLocationList}
            maxDisplayTags={2}
          />

          {/* Date Type */}
          <FormControl size="small" fullWidth>
            <InputLabel>Date Type</InputLabel>
            <Select
              value={dateType}
              label="Date Type"
              onChange={(e) => setDateType(e.target.value)}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              <MenuItem value="billingDate">Billing Date</MenuItem>
              <MenuItem value="returnDate">Return Date</MenuItem>
              <MenuItem value="apptDate">Appt Date</MenuItem>
            </Select>
          </FormControl>

          {/* Date Range */}
          <Stack direction="column" sx={{ position: "relative" }}>
            <TextField
              label="Date Range"
              size="small"
              value={formatedDateRangeFunc(selectedDate) || ""}
              disabled={!dateType}
              onClick={() => setIsPickerOpen(true)}
              autoComplete="off"
              readOnly
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedDate("");
                        setDateRange([null, null]);
                      }}
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />

            {isPickerOpen && (
              <Box
                sx={{
                  position: "absolute",
                  top: "95%",
                  zIndex: 1000,
                  background: "#fff",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.2)"
                }}
              >
                <CustomDateRangePicker
                  indexValue={0}
                  defaultDateRangeValue={selectedDate || ""}
                  onDateSelect={handleAccept}
                  handleCloseDatePicker={() => setIsPickerOpen(false)}
                  isRestrict={1}
                  maxDays={
                    selectedLocationList.length > 1 ? 31 : null
                  }
                />
              </Box>
            )}
          </Stack>
       
          <Button variant="contained" onClick={handleApply} fullWidth>
            Apply
          </Button>
          <Button variant="outlined" onClick={handleClear} fullWidth>
            Clear
          </Button>

          <Box sx={{ display: "flex", gap: 2, mb: 1 }}>
          <PermissionWrapper category="documents" level="READ_WRITE">
          <Button
            variant="contained"
            disabled={!hasUnsavedRows || isSaving}
            onClick={handleSave}
          >
            Save
          </Button>

          <Button
            variant="outlined"
            disabled={!hasUnsavedRows || isSaving}
            onClick={handleCancel}
          >
            Cancel
          </Button>
          </PermissionWrapper>
        </Box>
        </ResponsiveGrid>
      </Box>
    </Box>
  );
};

export default DocumentAuditFilterSection;
